@if (isMobile() && mode() !== 'closed') {
  <div class="mobile-overlay" (click)="nav.setMode('closed')"></div>
}

<aside
  class="rail cafe"
  [class.expanded]="mode() === 'expanded'"
  [class.collapsed]="mode() === 'collapsed'"
  [class.closed]="mode() === 'closed'"
>

  <!-- ─── En-tête : logo, repli ────────────────────────────── -->
  <header class="rail-head">
    <a routerLink="/" class="rail-logo-link">
      @if (mode() === 'expanded' && !isMobile()) {
        <span class="rail-logo">mokah<span class="cafe-plus">+</span></span>
        <span class="rail-logo-sub-line">Réveillez votre organisation</span>
        @if (nav.trialLabel() === 'active') {
          <span class="rail-trial-badge">Version d'essai</span>
        } @else if (nav.trialLabel() === 'expired') {
          <span class="rail-trial-badge expired">Version d'essai terminée</span>
        }
      } @else {
        <span class="rail-logo rail-logo-sm">m<span class="cafe-plus">+</span></span>
      }
    </a>

    @if (mode() === 'expanded' && !isMobile()) {
      <button
        class="rail-toggle-btn rail-toggle-inline"
        (click)="nav.setMode('collapsed')"
        aria-label="Réduire la navigation"
        appTooltip="Réduire"
        tooltipPosition="right"
      >
        <ng-icon name="iconoirSidebarCollapse" size="14"></ng-icon>
      </button>
    }
    @if (isMobile() && mode() !== 'closed') {
      <button
        class="rail-toggle-btn rail-toggle-inline close-btn"
        (click)="nav.setMode('closed')"
        aria-label="Fermer la navigation"
      >
        <ng-icon name="iconoirXmark" size="14"></ng-icon>
      </button>
    }
  </header>

  <nav class="rail-nav" data-tour="dashboard.home.sidenav" [class.quick-action-open]="nav.openQuickActionKey() !== null" aria-label="Navigation principale"
       (click)="nav.onRailLinkClick($event)">
    @for (item of nav.personalNavItems(); track item.route) {
      <a
        class="rail-item"
        [routerLink]="item.route"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{exact: item.routerLinkExact ?? false}"
        [appTooltip]="mode() !== 'expanded' ? item.label : ''"
        tooltipPosition="right"
      >
        <span class="rail-dot"><ng-icon [name]="item.icon" size="18"></ng-icon></span>
        @if (mode() === 'expanded') {
          <span class="rail-text">{{ item.label }}</span>
        }
      </a>
    }

    <!-- ─── Mes applications : carré de couleur, module actif déplié ─── -->
    @if (nav.appNavItems().length > 0) {
      <div class="rail-divider rail-divider--apps">
        @if (mode() === 'expanded') {
          <span class="rail-divider-label">Mes applications</span>
        }
      </div>
      @for (item of nav.appNavItems(); track item.route) {
        <div
          class="rail-item-row"
          [class.has-flyout]="nav.itemHasFlyout(item)"
          (mouseenter)="nav.onFlyoutAnchorMouseEnter(item)"
          (mouseleave)="nav.onFlyoutAnchorMouseLeave(item)"
        >
          <a
            class="rail-item"
            [routerLink]="item.route"
            routerLinkActive="active"
            #rla="routerLinkActive"
            [class.active]="nav.isGroupActive(item)"
            [routerLinkActiveOptions]="{exact: item.routerLinkExact ?? false}"
            [attr.aria-expanded]="mode() === 'expanded' && item.route === '/project-management' ? rla.isActive : (mode() === 'expanded' && nav.isSpacesGroup(item) ? nav.isGroupActive(item) : null)"
            [appTooltip]="(mode() !== 'expanded' && !nav.itemHasFlyout(item)) ? item.label : ''"
            tooltipPosition="right"
            (click)="nav.onNavItemClick($event, item)"
          >
            <span class="rail-dot cafe-icon" [attr.data-tone]="nav.toneFor(item.route)">
              <ng-icon [name]="item.icon" size="18"></ng-icon>
            </span>
            @if (mode() === 'expanded') {
              <span class="rail-text">{{ item.label }}</span>
            }
            @if (item.badge && item.badge() > 0) {
              <span class="rail-badge">{{ item.badge!() }}</span>
            }
            @if (mode() === 'expanded' && rla.isActive && item.route === '/project-management' && nav.hasProjectSubitems()) {
              <ng-icon name="iconoirNavArrowDown" size="14" class="cafe-chevron" aria-hidden="true"></ng-icon>
            }
          </a>

            @if (mode() === 'expanded') {
              @if (item.route === '/calendar' && nav.hasCalendars()) {
                <button
                  type="button"
                  class="rail-item-plus"
                  (click)="nav.openQuickPresence($event)"
                  appTooltip="Nouvelle présence"
                  tooltipPosition="top"
                  aria-label="Nouvelle présence"
                >
                  <ng-icon name="iconoirPlus" size="14"></ng-icon>
                </button>
                @if (nav.isQuickActionOpen('presence')) {
                  <app-popover [open]="true" [config]="{ position: 'right', minWidth: '0' }" (closed)="nav.closeQuickAction()">
                    <app-quick-presence-popover (created)="nav.onQuickActionCreated()" (dismissed)="nav.closeQuickAction()" />
                  </app-popover>
                }
              }

              @if (item.route === '/project-management' && nav.showProjectsParentPlus()) {
                <button
                  type="button"
                  class="rail-item-plus"
                  (click)="nav.openQuickTaskGeneric($event)"
                  appTooltip="Nouvelle tâche"
                  tooltipPosition="top"
                  aria-label="Nouvelle tâche"
                >
                  <ng-icon name="iconoirPlus" size="14"></ng-icon>
                </button>
                @if (nav.isQuickActionOpen('task-parent')) {
                  <app-popover [open]="true" [config]="{ position: 'right', minWidth: '0' }" (closed)="nav.closeQuickAction()">
                    <app-quick-task-popover
                      [projects]="nav.quickTaskProjects()"
                      [initialProjectId]="nav.quickTaskInitialProjectId()"
                      (created)="nav.onQuickActionCreated()"
                      (dismissed)="nav.closeQuickAction()"
                    />
                  </app-popover>
                }
              }

              @if (item.route === '/materials') {
                <button
                  type="button"
                  class="rail-item-plus"
                  (click)="nav.openQuickInventory($event)"
                  appTooltip="Nouvel équipement"
                  tooltipPosition="top"
                  aria-label="Nouvel équipement"
                >
                  <ng-icon name="iconoirPlus" size="14"></ng-icon>
                </button>
                @if (nav.isQuickActionOpen('inventory')) {
                  <app-popover [open]="true" [config]="{ position: 'right', minWidth: '0' }" (closed)="nav.closeQuickAction()">
                    <app-quick-inventory-popover (created)="nav.onQuickActionCreated()" (dismissed)="nav.closeQuickAction()" />
                  </app-popover>
                }
              }
            }

            @if (nav.isSpacesGroup(item) && mode() === 'collapsed' && !isMobile()) {
              <div
                class="rail-flyout"
                [class.open]="nav.isFlyoutOpen(item.route)"
                (mouseenter)="nav.onFlyoutPanelMouseEnter()"
                (mouseleave)="nav.onFlyoutPanelMouseLeave()"
              >
                <div class="rail-flyout-title">Espaces &amp; ressources</div>
                <ng-container [ngTemplateOutlet]="spacesSubitems" />
              </div>
            }

            @if (item.route === '/project-management' && mode() === 'collapsed' && nav.hasProjectSubitems() && !isMobile()) {
              <div
                class="rail-flyout"
                [class.open]="nav.isFlyoutOpen(item.route)"
                (mouseenter)="nav.onFlyoutPanelMouseEnter()"
                (mouseleave)="nav.onFlyoutPanelMouseLeave()"
              >
                <div class="rail-flyout-title">Projets</div>
                <ng-container [ngTemplateOutlet]="projectSubitems" />
                @if (nav.showProjectsParentPlus()) {
                  <button type="button" class="rail-flyout-add" (click)="nav.openQuickTaskGeneric($event)">
                    <ng-icon name="iconoirPlus" size="13"></ng-icon>
                    <span>Nouvelle tâche…</span>
                  </button>
                  @if (nav.isQuickActionOpen('task-parent')) {
                    <app-popover [open]="true" [config]="{ position: 'right', minWidth: '0' }" (closed)="nav.closeQuickAction()">
                      <app-quick-task-popover
                        [projects]="nav.quickTaskProjects()"
                        [initialProjectId]="nav.quickTaskInitialProjectId()"
                        (created)="nav.onQuickActionCreated()"
                        (dismissed)="nav.closeQuickAction()"
                      />
                    </app-popover>
                  }
                }
              </div>
            }
          </div>

        <!-- Espaces & ressources (module Calendrier, MOKA-248) : déplié seulement dans le module
             (/calendar, /room-reservations), comme les projets (MOKA-336) ; calendriers de
             l'organisation puis « Salles ». -->
        @if (nav.isSpacesGroup(item) && mode() === 'expanded' && nav.isGroupActive(item)) {
          <div class="rail-sublist">
            <ng-container [ngTemplateOutlet]="spacesSubitems" />
          </div>
        }

        <!-- Projets actif : dossiers favoris et projets. Les autres modules ont
             leur navigation dans l'en-tête. -->
        @if (item.route === '/project-management' && mode() === 'expanded' && rla.isActive && nav.hasProjectSubitems()) {
          <div class="rail-sublist">
            <ng-container [ngTemplateOutlet]="projectSubitems" />
          </div>
        }
      }
    }

    <ng-template #spacesSubitems>
      @for (cal of nav.spaceCalendars(); track cal.id) {
        <div class="rail-subitem-row">
          <a class="rail-subitem" [routerLink]="['/calendar', 'v', cal.slug]" routerLinkActive="active">{{ cal.label }}</a>
        </div>
      }
      <div class="rail-subitem-row rail-subitem-row--rooms" [class.is-first]="!nav.spaceCalendars().length">
        <a class="rail-subitem rail-subitem-rooms" routerLink="/room-reservations" [class.active]="nav.isRoomsActive()">
          <ng-icon name="iconoirBuilding" size="14" aria-hidden="true"></ng-icon>
          <span>Salles</span>
        </a>
      </div>
    </ng-template>

    <ng-template #projectSubitems>
      <!-- 5 entrées au plus : dossiers favoris (vers le hub, dossier sélectionné), puis projets -->
      @for (group of nav.menuFolders(); track group.folder.id) {
        <div class="rail-subitem-row rail-folder-row">
          <a class="rail-subitem rail-subitem-folder" routerLink="/project-management" [queryParams]="{ dossier: group.folder.id }">
            <span class="rail-folder-swatch" [style.background]="group.folder.color || 'var(--neutral-400)'" aria-hidden="true"></span>
            <span class="rail-folder-name">{{ group.folder.name }}</span>
          </a>
        </div>
      }

      @for (project of nav.menuProjects(); track project.id) {
        <div class="rail-subitem-row">
          <a class="rail-subitem" [routerLink]="['/project-management', nav.getProjectSlug(project)]" routerLinkActive="active">
            {{ project.name }}
          </a>
          @if (nav.showProjectsSubitemPlus()) {
            <button
              type="button"
              class="rail-subitem-plus"
              (click)="nav.openQuickTaskForProject($event, project)"
              appTooltip="Nouvelle tâche"
              tooltipPosition="top"
              aria-label="Nouvelle tâche"
            >
              <ng-icon name="iconoirPlus" size="12"></ng-icon>
            </button>
            @if (nav.isQuickActionOpen('task-' + project.id)) {
              <app-popover [open]="true" [config]="{ position: 'right', minWidth: '0' }" (closed)="nav.closeQuickAction()">
                <app-quick-task-popover
                  [projects]="nav.quickTaskProjects()"
                  [initialProjectId]="nav.quickTaskInitialProjectId()"
                  (created)="nav.onQuickActionCreated()"
                  (dismissed)="nav.closeQuickAction()"
                />
              </app-popover>
            }
          }
        </div>
      }
      <a class="rail-subitem rail-subitem-more" routerLink="/project-management" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active">
        <ng-icon name="iconoirArrowRight" size="13"></ng-icon>
        <span>Tous mes projets</span>
      </a>
    </ng-template>
  </nav>

  <div class="rail-spacer"></div>

  <!-- ─── Assistant : Koffi ──────────────────────────────────── -->
  @if (nav.assistantEnabled()) {
    @if (mode() === 'expanded') {
      <!-- Carte condensée (MOKA-327) : toute la carte ouvre Koffi ; pose « parole », jamais celle du bandeau d'accueil. -->
      <button type="button" class="cafe-assistant" (click)="nav.openAssistant()" aria-label="Parler à Koffi, l’assistant">
        <img class="cafe-assistant-koffi" src="assets/images/koffi/koffi-parle.png" alt="" width="512" height="512" aria-hidden="true" />
        <span class="cafe-assistant-body">
          <span class="cafe-assistant-title">Parler à Koffi</span>
          <span class="cafe-assistant-text">Posez-lui vos questions</span>
        </span>
        <span class="cafe-assistant-icon" aria-hidden="true"><ng-icon name="iconoirChatLines" size="16" /></span>
      </button>
    } @else {
      <button
        type="button"
        class="cafe-assistant-round"
        (click)="nav.openAssistant()"
        aria-label="Parler à Koffi"
        appTooltip="Parler à Koffi"
        tooltipPosition="right"
      >
        <img src="assets/images/koffi/koffi-avatar.png" alt="" width="256" height="256" aria-hidden="true" />
      </button>
    }
  }

  <!-- ─── Administration ───────────────────────────────────── -->
  @if (nav.adminNavItems().length > 0) {
    <footer class="rail-foot" data-tour="dashboard.home.sidenav-admin">
      <div class="rail-divider">
        @if (mode() === 'expanded') {
          <span class="rail-divider-label">Administration</span>
        }
      </div>
      @for (item of nav.adminNavItems(); track item.route) {
        <a
          class="rail-item"
          [routerLink]="item.route"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: item.routerLinkExact ?? false}"
          [appTooltip]="mode() !== 'expanded' ? item.label : ''"
          tooltipPosition="right"
        >
          <span class="rail-dot"><ng-icon [name]="item.icon" size="18"></ng-icon></span>
          @if (mode() === 'expanded') {
            <span class="rail-text">{{ item.label }}</span>
          }
        </a>
      }
    </footer>
  }

  <!-- ─── Pied : identité et organisation ───────────────────── -->
  <div class="cafe-foot" data-tour="dashboard.home.sidenav-foot" [class.is-collapsed]="mode() !== 'expanded'">
    <div class="rail-profile-popover-anchor cafe-foot-main">
      <button
        type="button"
        class="cafe-foot-btn"
        (click)="nav.toggleProfileMenu()"
        [attr.aria-label]="'Menu de ' + fullName()"
        [appTooltip]="mode() !== 'expanded' ? fullName() : ''"
        tooltipPosition="right"
      >
        <app-avatar [imagePass]="nav.authService.profile?.['photo_url'] ?? ''" [textPass]="fullName()" [sizePass]="34" />
        @if (mode() === 'expanded') {
          <span class="cafe-foot-text">
            <span class="cafe-foot-name">{{ fullName() }}</span>
            <span class="cafe-foot-meta">{{ nav.activeOrganisationLabel() ?? '—' }}</span>
          </span>
        }
      </button>

      <app-popover [open]="nav.showProfileMenu()" [config]="{ position: 'top-right', minWidth: '210px' }" (closed)="nav.closeProfileMenu()">
        <div class="popover-profile-header">
          @if (nav.authService.profile?.['organisation']?.label) {
            <span class="popover-org-tag">{{ nav.authService.profile?.['organisation']?.label }}</span>
          }
          <span class="popover-profile-header-name">{{ fullName() }}</span>
          <span class="popover-profile-header-email">{{ nav.authService.profile?.['email'] }}</span>
          @if (nav.authService.profile?.['agency']?.label) {
            <span class="popover-profile-header-meta">Agence : {{ nav.authService.profile?.['agency']?.label }}</span>
          }
          @if (nav.userRoleLabels().length > 0) {
            <div class="popover-profile-header-roles">
              @for (label of nav.userRoleLabels(); track label) {
                <span class="popover-profile-role-badge">{{ label }}</span>
              }
            </div>
          }
        </div>
        <app-popover-item icon="iconoirCamera" (clicked)="nav.openAvatarChangeDialog(); nav.closeProfileMenu()">Changer mon avatar</app-popover-item>
        @if (!nav.authService.profile?.['external']) {
          <app-popover-item icon="iconoirSettings" (clicked)="nav.goToAccount()">Mon compte</app-popover-item>
          <app-popover-item icon="iconoirMail" (clicked)="nav.goToEmailPreferences()">Mes e-mails</app-popover-item>
          @if (nav.isModuleEnabled('human_resources_enable')) {
            <app-popover-item icon="iconoirBook" (clicked)="nav.goToCareer()">Ma carrière</app-popover-item>
          }
          @if (nav.isModuleEnabled('inventory_enable')) {
            <app-popover-item icon="iconoirLaptop" (clicked)="nav.goToMyDevices()">Mon matériel</app-popover-item>
          }
        }
        <app-popover-divider />
        <app-popover-item icon="iconoirLogOut" variant="danger" (clicked)="nav.onLogout()">Déconnexion</app-popover-item>
      </app-popover>
    </div>

    <div class="rail-org-popover-anchor">
      <button
        type="button"
        class="cafe-foot-org"
        [class.open]="nav.showOrgSwitcher()"
        (click)="nav.toggleOrgSwitcher()"
        aria-label="Changer d'organisation"
        appTooltip="Mes organisations"
        tooltipPosition="right"
      >
        <ng-icon name="iconoirBuilding" size="15"></ng-icon>
      </button>

      <app-popover [open]="nav.showOrgSwitcher()" [config]="{ position: 'top-right', minWidth: '250px' }" (closed)="nav.closeOrgSwitcher()">
        <div class="popover-orgs-head">
          <span class="popover-orgs-title">Mes organisations</span>
          <button
            type="button"
            class="popover-orgs-add"
            (click)="nav.createOrganisation()"
            appTooltip="Créer une organisation"
            tooltipPosition="top"
            aria-label="Créer une organisation"
          >
            <ng-icon name="iconoirPlus" size="14"></ng-icon>
          </button>
        </div>
        @for (org of nav.myOrganisations(); track org.organisation_id) {
          <button
            type="button"
            class="popover-org-row"
            [class.current]="nav.isActiveOrganisation(org.organisation_id)"
            (click)="nav.switchOrganisation(org.organisation_id)"
          >
            <ng-icon name="iconoirBuilding" size="16" class="popover-org-row-icon"></ng-icon>
            <span class="popover-org-row-label">{{ org.organisation?.label }}</span>
            @if (nav.isActiveOrganisation(org.organisation_id)) {
              <span class="popover-org-row-tag">Actuelle</span>
              <ng-icon name="iconoirCheck" size="14" class="popover-org-row-check"></ng-icon>
            }
          </button>
        }
      </app-popover>
    </div>
  </div>

  @if (mode() === 'collapsed' && !isMobile()) {
    <button class="rail-expand-btn" (click)="nav.setMode('expanded')" aria-label="Étendre la navigation" appTooltip="Étendre" tooltipPosition="right">
      <ng-icon name="iconoirSidebarExpand" size="14"></ng-icon>
    </button>
  }
</aside>
